export default __webpack_public_path__ + "static/media/quick-buyer-choice.99c30cf5.svg";